<template>
  <div>
    <mu-content-block v-if="initialLoad" style="text-align: center">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <follower-item v-if="hasItems" :items="items" type="following"></follower-item>
    <div v-if="initialLoad === false || isLoading === false" id="infiniteScrollDetector"></div>
    <p v-if="!initialLoad && !hasItems">This user isn't following anyone</p>
  </div>
</template>

<script>

  import ProfileFollowerMixin from './../../mixins/ProfileFollowerMixin'
  import FollowerItem from "../../components/Profile/FollowerItem/FollowerItem";
  import "./Profile.less";

  export default {
    components: {FollowerItem},
    props: ['profile'],
    mixins: [
      ProfileFollowerMixin
    ],
    name: 'profile-following',
    watch: {
      profile: function() {
        this.initMounted();
      }
    }
  }

</script>



// WEBPACK FOOTER //
// ProfileFollowing.vue?2221d8f7